import "../util/momentTimezone"; // set default timezone for moment

import React, { useState } from "react";
import { ProvideSite } from "../util/sites";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { Switch, Route, Router } from "./../util/router";

import { loginSession, logoutSession } from "../util/authorization";
import { ProvideUser } from "../util/user";
import useKeycloakInstance from "./../util/keycloak";

import AdminPage from "./administration";
import AlarmsPage from "./alarms";
import AlarmLogPage from "./alarm-log";
import AnalyticsPage from "./analytics";
import DashboardPage from "./dashboard";
import ExtractPage from "./extract";
import IndexPage from "./index";
import MapPage from "./map";
import BESSPage from "./bess";
import OverviewPage from "./overview";
import PlaygroundPage from "./playground";
import SignOnPage from "./signon";
import ErrorPage from "./error";
import LicenseInProgressPage from "./licenseinprogress";
import LogoutPage from "./logout";

import NotFoundPage from "../components/general/NotFound";
import Navbar from "../components/general/Navbar";
import Loader from "../components/general/Loader";
import KCPassResetPopup from "../components/general/KCPassResetPopup";

import { NonceProtectProvider } from '../util/nonceProtect';

import TimezoneNotice from "../components/general/TimezoneNotice";

import "datatables.net-bs";
import "datatables.net-bs/css/dataTables.bootstrap.min.css";
import "datatables.net-buttons-dt";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-responsive-dt";

import Documentation from "../components/documentation/Documentation";
// import customized ant design css (global styles removed)
import '../antd-style.css';

// application styles
import '../app.css';
import DataDownloadDoc from "../components/documentation/dataDownload/DataDownloadDoc";
import DataDownloadSidebar from "../components/documentation/dataDownload/DataDownloadSidebar";
import NoticePopup from "../components/alarms/NoticePopup";
import PVOnlyPage from "../components/admin/PVOnlyPage";
import BESSOnlyPage from "../components/admin/BESSOnlyPage";

function App() {
	const [keycloakInstance] = useKeycloakInstance();
	return <PreApp keycloak={keycloakInstance} />;
}

function PreApp(props) {
	const keycloak = props.keycloak;
	const [appReady, setAppReady] = useState(false);

	const [user, setUser] = useState(null);
	/**
	 * Logs Keycloak Events
	 * @param {Keycloak events} event
	 * @param {Keycloak errors} error
	 */
	const eventLogger = (event, error) => {
		const user = keycloak.tokenParsed;
		switch (event) {
			case "onReady":
				setAppReady(true);
				break;

			case "onAuthSuccess":
				console.log("Access authenticated!");
				loginSession(keycloak.token);
				setUser(user);
				break;

			case "onTokenExpired":
				console.log("Token expired. Attempting to refresh");
				break;

			case "onAuthLogout":
				logoutSession();
				keycloak.logout();

				alert("Your session has expired. Please login again");

				break;

			case "onAuthRefreshSuccess":
				console.log("Refreshing token..");
				break;

			default:
				break;
		}
	};

	/**
	 * Logs changes to token
	 * @param {Keycloak tokens} tokens
	 */
	const tokenLogger = (token) => {
		// console.log('token:', token);
	};

	return (
		<ReactKeycloakProvider
			authClient={keycloak}
			onEvent={eventLogger}
			onTokens={tokenLogger}
		>
			<NonceProtectProvider>
				<ProvideUser>
					<ProvideSite>
						<Router>
							<>
								<Navbar />
								<Switch>
									<Route exact path="/" component={IndexPage} />
									<Route
										exact
										path="/solar/signin"
										component={() => <SignOnPage kc={keycloak} />}
									/>
									<Route
										exact
										path="/solar/inprogress"
										component={() => <LicenseInProgressPage user={keycloak} />}
									/>
									{appReady ? (
										<>
											<Route
												exact
												path="/solar/logout"
												component={() => (
													<LogoutPage appReady={appReady} kc={keycloak} />
												)}
											/>
											<Route
												exact
												path="/solar/overview"
												component={() => <OverviewPage />}
											/>
											<Route
												path="/solar/dashboard/:site_id"
												component={(props) => <PVOnlyPage><DashboardPage route={props} /></PVOnlyPage>}
											/>
											<Route
												exact
												path="/solar/analytics"
												component={() => <PVOnlyPage><AnalyticsPage /></PVOnlyPage>}
											/>
											<Route
												// exact
												path="/solar/administration/"
												component={() => <AdminPage />}
											/>
											{/* <Route
												path="/solar/administration/:tab"
												component={() => <AdminPage />}
											/> */}
											<Route
												exact
												path="/solar/map"
												component={() => <PVOnlyPage><MapPage /></PVOnlyPage>}
											/>
											<Route
												exact
												path="/solar/bess"
												component={() => <BESSOnlyPage><BESSPage /></BESSOnlyPage>}
											/>
											<Route
												exact
												path="/solar/extract"
												component={() => <PVOnlyPage><ExtractPage /></PVOnlyPage>}
											/>
											<Route
												exact
												path="/solar/alarms"
												component={() => <PVOnlyPage><AlarmsPage /></PVOnlyPage>}
											/>
											<Route
												exact
												path="/solar/alarm-log"
												component={() => <AlarmLogPage />}
											/>
											<Route
												exact
												path="/solar/playground"
												component={() => <PlaygroundPage user={user} />}
											/>

												<Route
													exact
													path="/solar/error"
													component={() => <ErrorPage user={user} />}
												/>
												
												{/* Documentation */}
												<Route
													exact
													path="/solar/documentation/download"
													component={() => <Documentation DocComponent={DataDownloadDoc} DocSideBarComponent={DataDownloadSidebar} backRoutePath="/solar/administration/download" />}
												/>
										</>
									) : (
										<Loader />
									)}
									<Route component={NotFoundPage} />
								</Switch>
								{/* <TimezoneNotice /> */}
								<KCPassResetPopup />
								<NoticePopup />
							</>
						</Router>
					</ProvideSite>
				</ProvideUser>
			</NonceProtectProvider>
		</ReactKeycloakProvider>
	);
}

export default App;
